import { render } from "./Signup.vue?vue&type=template&id=1d9cc9ce&ts=true"
import script from "./Signup.vue?vue&type=script&lang=ts"
export * from "./Signup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__